/* Princess Room — Pop-up « Article ajouté au panier », V4 (27/10/2026).
   Balisage et libellés : snippets/pr-cart-popup.liquid (via window.PR_CPOP).
   API publique inchangée : window.prCartPopupShow(addResp, opts).
   RÈGLE : tous les montants viennent d'UN SEUL /cart.js. Le prix unitaire porte
   toujours « each », le prix de ligne est à droite, le sous-total n'est que dans
   le bouton, légendé. L'ancienne version mêlait prix de ligne et barré unitaire. */
(function(){
  var pop=document.getElementById('prCpop');
  if(!pop)return;
  var C=window.PR_CPOP||{};
  var T=C.t||{};
  var CART_URL=C.cart||'/cart';
  var CHECKOUT_URL=C.checkout||'/checkout';
  var ROOT=C.root||'/';

  function withPreview(u){try{var pv=new URLSearchParams(location.search).get('preview_theme_id');if(pv){u+=(u.indexOf('?')>-1?'&':'?')+'preview_theme_id='+pv;}}catch(e){}return u;}
  function money2(c){c=parseInt(c,10);if(isNaN(c))return '';var cur=(C&&C.currency)||(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'EUR';var loc=(document.documentElement.lang||'fr').slice(0,2);try{return new Intl.NumberFormat(loc,{style:'currency',currency:cur}).format(c/100);}catch(e){var v=(Math.round(c)/100).toFixed(2).split('.');return v[0].replace(/\B(?=(\d{3})+(?!\d))/g,'\u00a0')+','+v[1]+'\u00a0'+cur;}}
  /* PR: whole amounts render without ".00" so JS prices match the Liquid ones ($490, not $490.00). */
  function money(c){return money2(c).replace(/[.,]00(\s|\u00a0)?(?=\D*$)/,'$1');}
  function $(id){return document.getElementById(id);}
  function esc(s){var d=document.createElement('div');d.textContent=(s==null?'':s);return d.innerHTML;}
  function plural(n){return n+' '+(n===1?T.item1:T.itemN);}

  /* La source de vérité est TOUJOURS le dernier /cart.js reçu. */
  var S={cart:null,expanded:false,justKey:null,justId:null,imgHint:''};
  var SAVE={};   /* variant_id -> économie UNITAIRE en centimes, depuis compare_at_price */
  var lastFocus=null;

  /* PR: the PR cart/popup re-render their own markup only. Horizon's header cart
     bubble was never refreshed, so it kept a stale count until a full reload. */
  function syncCartBubble(c){
    try{
      document.querySelectorAll('.cart-bubble__text-count').forEach(function(el){el.textContent=(c<100?String(c):'');});
      document.querySelectorAll('.cart-bubble').forEach(function(b){b.classList.toggle('visually-hidden',c===0);});
      var ci=document.querySelector('cart-icon');
      if(ci)ci.classList.toggle('header-actions__cart-icon--has-cart',c>0);
      sessionStorage.setItem('cart-count',JSON.stringify({value:String(c<100?c:''),timestamp:Date.now()}));
    }catch(e){}
  }

  var toastT;
  function prToast(msg){
    var t=$('prToast');if(!t)return;
    t.textContent=msg||T.generic||T.unavail;t.removeAttribute('hidden');
    clearTimeout(toastT);toastT=setTimeout(function(){t.setAttribute('hidden','');},4200);
  }

  /* Image : jamais d'image cassée. */
  function sized(raw,w){
    if(!raw)return '';
    var full=(raw.indexOf('//')===0)?('https:'+raw):raw;
    try{var u=new URL(full,location.origin);u.searchParams.set('width',w);return u.toString();}catch(e){return full;}
  }
  function setImg(raw){
    var img=$('prCpopImg'),box=$('prCpopImgBox');
    if(!img||!box)return;
    img.onload=null;img.onerror=null;box.classList.remove('has-img');
    if(!raw){img.removeAttribute('src');return;}
    var full=(raw.indexOf('//')===0)?('https:'+raw):raw;
    img.onload=function(){box.classList.add('has-img');};
    img.onerror=function(){img.onerror=function(){box.classList.remove('has-img');};if(img.src!==full)img.src=full;};
    img.src=sized(raw,220);
  }

  var _pcache={};
  function getProduct(handle){
    if(!handle)return Promise.reject();
    if(!_pcache[handle])_pcache[handle]=fetch(ROOT+'products/'+handle+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
    return _pcache[handle];
  }
  /* compare_at_price n'est pas dans /cart.js : on le lit sur /products/<handle>.js.
     C'est la SEULE source de l'économie affichée, et elle est toujours UNITAIRE. */
  function loadSaves(cart){
    var seen={},hs=[],i;
    for(i=0;i<cart.items.length;i++){var h=cart.items[i].handle;if(h&&!seen[h]){seen[h]=1;hs.push(h);}}
    hs=hs.slice(0,8);
    return Promise.all(hs.map(function(h){
      return getProduct(h).then(function(p){
        (p.variants||[]).forEach(function(v){
          if(v.compare_at_price&&v.price&&v.compare_at_price>v.price)SAVE[v.id]=v.compare_at_price-v.price;
        });
      }).catch(function(){});
    }));
  }

  function justItem(){
    var c=S.cart;if(!c||!c.items||!c.items.length)return null;
    var i;
    for(i=0;i<c.items.length;i++)if(c.items[i].key===S.justKey)return c.items[i];
    for(i=0;i<c.items.length;i++)if(c.items[i].id===S.justId)return c.items[i];
    return c.items[0];
  }

  function renderPeek(){
    var it=justItem();if(!it)return;
    setImg(it.image||S.imgHint||'');
    var q=$('prCpopQty');
    if(it.quantity>1){q.textContent='× '+it.quantity;q.removeAttribute('hidden');}else{q.setAttribute('hidden','');}
    $('prCpopName').textContent=it.product_title||it.title||'';
    var sav=SAVE[it.id]||0,left;
    /* À une seule unité, prix unitaire et prix de ligne sont le même nombre : on
       n'écrit le montant qu'une fois, à droite, et « each » disparaît avec lui. */
    if(it.quantity>1){
      left=esc(money(it.final_price)+' '+T.each)+(sav>0?' · <b>'+esc(T.save+' '+money(sav)+' '+T.each)+'</b>':'');
    }else{
      left=sav>0?('<b>'+esc(T.save+' '+money(sav))+'</b>'):'';
    }
    $('prCpopUnit').innerHTML=left;
    $('prCpopLine').textContent=money(it.final_line_price);
  }

  function rowHtml(it,isNew){
    var sav=SAVE[it.id]||0;
    var variant=(it.variant_title&&it.variant_title!=='Default Title')?it.variant_title:'';
    var cmp=sav>0?('<s>'+esc(money(it.final_price+sav))+'</s>'):'';
    return ''+
      '<div class="pr-cpop__row'+(isNew?' pr-cpop__row--new':'')+'" data-key="'+esc(it.key)+'">'+
        '<img src="'+esc(sized(it.image,180))+'" alt="" decoding="async">'+
        '<div class="pr-cpop__rmeta">'+
          (isNew?'<p class="pr-cpop__eyebrow">'+esc(T.just)+'</p>':'')+
          '<p class="pr-cpop__rname">'+esc(it.product_title||it.title||'')+'</p>'+
          (variant?'<p class="pr-cpop__rvar">'+esc(variant)+'</p>':'')+
          '<p class="pr-cpop__runit">'+esc(money(it.final_price)+' '+T.each)+cmp+'</p>'+
          '<div class="pr-cpop__qbox">'+
            '<span class="pr-cpop__step">'+
              '<button type="button" data-act="dec" aria-label="'+esc(T.minus)+'"'+(it.quantity<=1?' disabled':'')+'>&minus;</button>'+
              '<span class="q">'+it.quantity+'</span>'+
              '<button type="button" data-act="inc" aria-label="'+esc(T.plus)+'">+</button>'+
            '</span>'+
            '<button type="button" class="pr-cpop__rm" data-act="rm">'+esc(T.remove)+'</button>'+
          '</div>'+
        '</div>'+
        '<div class="pr-cpop__rprice">'+
          '<b>'+esc(money(it.final_line_price))+'</b>'+
          (sav>0?'<i>'+esc(T.yousave+' '+money(sav*it.quantity))+'</i>':'')+
        '</div>'+
      '</div>';
  }

  function renderDetail(){
    var c=S.cart;if(!c)return;
    $('prCpopDHead').textContent=T.yourcart+' · '+plural(c.item_count);
    var jk=(justItem()||{}).key, html='', i;
    for(i=0;i<c.items.length;i++)if(c.items[i].key===jk)html+=rowHtml(c.items[i],true);
    for(i=0;i<c.items.length;i++)if(c.items[i].key!==jk)html+=rowHtml(c.items[i],false);
    $('prCpopList').innerHTML=html;
    var tot=0;
    for(i=0;i<c.items.length;i++)tot+=(SAVE[c.items[i].id]||0)*c.items[i].quantity;
    $('prCpopLedger').innerHTML=''+
      '<p class="pr-cpop__lrow"><span>'+esc(T.subtotal+' · '+plural(c.item_count))+'</span><span>'+esc(money(c.items_subtotal_price))+'</span></p>'+
      (tot>0?'<p class="pr-cpop__lrow pr-cpop__lrow--save"><span>'+esc(T.savings)+'</span><span>&minus;'+esc(money(tot))+'</span></p>':'')+
      '<p class="pr-cpop__lrow"><span>'+esc(T.shipping)+'</span><span>'+esc(T.free+' · '+T.delay)+'</span></p>'+
      '<p class="pr-cpop__lrow pr-cpop__lrow--muted"><span>'+esc(T.tax)+'</span><span>'+esc(T.taxcalc)+'</span></p>'+
      '<p class="pr-cpop__due"><span>'+esc(T.due)+'</span><b>'+esc(money(c.total_price))+' <em>'+esc(T.plustax)+'</em></b></p>';
  }

  function renderFoot(){
    var c=S.cart;if(!c)return;
    $('prCpopCta').textContent=money(c.total_price);
    $('prCpopCap').textContent=S.expanded?T.capFoot:(T.capA+' '+plural(c.item_count)+' · '+T.capB);
    $('prCpopMoreTxt').textContent=(S.expanded?T.hide:T.details+' ('+c.item_count+')');
  }

  function render(){
    if(!S.cart)return;
    if(S.expanded){$('prCpopPeek').setAttribute('hidden','');$('prCpopDetail').removeAttribute('hidden');renderDetail();}
    else{$('prCpopDetail').setAttribute('hidden','');$('prCpopPeek').removeAttribute('hidden');renderPeek();}
    renderFoot();
  }

  function applyCart(cart){
    S.cart=cart;
    syncCartBubble(cart.item_count||0);
    /* Panier vidé depuis le niveau 2 : il n'y a plus rien à montrer ni à payer. */
    if(!cart.item_count){closePop();return;}
    render();
    loadSaves(cart).then(render);
    try{document.dispatchEvent(new CustomEvent('cart:refresh'));}catch(e){}
  }
  function pullCart(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'},cache:'no-store'})
      .then(function(r){return r.json();})
      .then(function(c){applyCart(c);return c;});
  }

  function setExpanded(on){
    S.expanded=!!on;
    pop.classList.toggle('is-open',S.expanded);
    $('prCpopGrab').setAttribute('aria-expanded',S.expanded?'true':'false');
    $('prCpopGrab').setAttribute('aria-label',S.expanded?T.hideA:T.open);
    $('prCpopMore').setAttribute('aria-expanded',S.expanded?'true':'false');
    render();
    $('prCpopScroll').scrollTop=0;
  }
  function openPop(){
    lastFocus=document.activeElement;
    pop.removeAttribute('hidden');
    document.documentElement.classList.add('pr-cpop-open');
    document.documentElement.style.overflow='hidden';
    setTimeout(function(){try{$('prCpopGrab').focus();}catch(e){}},0);
  }
  function closePop(){
    pop.setAttribute('hidden','');
    document.documentElement.classList.remove('pr-cpop-open');
    document.documentElement.style.overflow='';
    $('prCpopErr').setAttribute('hidden','');
    setExpanded(false);
    try{if(lastFocus&&lastFocus.focus)lastFocus.focus();}catch(e){}
  }
  pop.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-close]')){closePop();return;}
    if(t.closest('[data-toggle]')){setExpanded(!S.expanded);return;}
  });
  /* Clavier : Échap ferme, Tab reste dans la fenêtre. */
  document.addEventListener('keydown',function(e){
    if(pop.hasAttribute('hidden'))return;
    if(e.key==='Escape'){closePop();return;}
    if(e.key!=='Tab')return;
    /* Les deux niveaux coexistent dans le DOM : on ne retient que ce qui est affiché. */
    var f=[].slice.call(pop.querySelectorAll('a[href],button:not([disabled])')).filter(function(el){return el.offsetParent!==null;});
    if(!f.length)return;
    var first=f[0],last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });
  $('prCpopGo').setAttribute('href',withPreview(CHECKOUT_URL));

  /* Quantités : intention ABSOLUE par ligne, coalescée, envoyée en série.
     Même mécanique que snippets/pr-cart-js.liquid : jamais de delta, donc cinq clics
     rapides font réellement +5 et aucune course n'est possible. */
  var WANT={},INFLIGHT=false,TIMER=null,COALESCE_MS=220;
  function markStale(key){
    var list=$('prCpopList');
    var row=list&&list.querySelector('[data-key="'+(window.CSS&&CSS.escape?CSS.escape(key):key)+'"]');
    if(row)row.classList.add('is-stale');
  }
  function schedule(){if(TIMER)clearTimeout(TIMER);TIMER=setTimeout(send,COALESCE_MS);}
  function send(){
    TIMER=null;
    if(INFLIGHT)return;
    var keys=Object.keys(WANT);
    if(!keys.length)return;
    INFLIGHT=true;
    var batch={},i=0,k;
    for(k in WANT)batch[k]=WANT[k];
    function done(ok){
      for(var c in batch)if(WANT[c]===batch[c])delete WANT[c];
      pullCart().then(function(){
        INFLIGHT=false;
        if(!ok)$('prCpopErr').removeAttribute('hidden');
        if(Object.keys(WANT).length)schedule();
      },function(){INFLIGHT=false;$('prCpopErr').removeAttribute('hidden');});
    }
    function next(){
      if(i>=keys.length){done(true);return;}
      var key=keys[i++];
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:batch[key]})})
        .then(function(r){if(!r.ok)throw 0;return r.json();})
        .then(function(){next();})
        .catch(function(){done(false);});
    }
    next();
  }
  function want(key,qty){
    if(!(qty>0))qty=0;
    WANT[key]=qty;
    $('prCpopErr').setAttribute('hidden','');
    markStale(key);
    schedule();
  }
  function displayedQty(key){
    var c=S.cart;if(!c)return 0;
    for(var i=0;i<c.items.length;i++)if(c.items[i].key===key)return c.items[i].quantity;
    return 0;
  }
  $('prCpopList').addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-act]');
    if(!btn)return;
    var row=btn.closest('.pr-cpop__row');if(!row)return;
    var key=row.getAttribute('data-key');
    var base=(key in WANT)?WANT[key]:displayedQty(key);
    var act=btn.getAttribute('data-act');
    if(act==='inc')want(key,base+1);
    else if(act==='dec')want(key,base-1);
    else if(act==='rm')want(key,0);
  });
  $('prCpopRetry').addEventListener('click',function(){
    $('prCpopErr').setAttribute('hidden','');
    pullCart().catch(function(){$('prCpopErr').removeAttribute('hidden');});
  });

  /* ——— API publique, inchangée ——— */
  window.prCartPopupShow=function(addResp,opts){
    opts=opts||{};
    var hasItem=addResp&&((addResp.items&&addResp.items.length)||addResp.id);
    if(!hasItem&&addResp&&(addResp.status>=400||addResp.description||addResp.message)){
      prToast(addResp.description||addResp.message||T.unavail);
      return;
    }
    var first=(addResp&&addResp.items&&addResp.items[0])||addResp||{};
    S.justKey=first.key||null;
    S.justId=first.id||first.variant_id||null;
    S.imgHint=opts.imgHint||'';
    S.expanded=false;
    pop.classList.remove('is-open');
    openPop();
    /* Rendu immédiat avec la réponse de /cart/add.js, puis correction par /cart.js. */
    if(first.key){
      S.cart={item_count:first.quantity||1,items:[first],items_subtotal_price:first.final_line_price||first.line_price||0,total_price:first.final_line_price||first.line_price||0};
      try{render();}catch(e){}
    }
    pullCart().catch(function(){});
  };

  /* ——— Ajout depuis TOUTES les cartes produit (pr-card, pr-bsc, etc.) ——— */
  document.addEventListener('submit',function(e){
    var form=e.target.closest&&e.target.closest('form[action*="/cart/add"]');
    if(!form||form.getAttribute('id')==='prForm'||form.classList.contains('pr-pdp__form'))return;
    var idEl=form.querySelector('[name="id"]');
    if(!idEl)return;
    e.preventDefault();
    var btn=form.querySelector('button[type=submit]')||form.querySelector('button');
    if(btn)btn.disabled=true;
    var card=form.closest('.pr-card')||form.closest('.pr-bsc')||form.parentElement||form;
    var imgEl=card.querySelector&&card.querySelector('img');
    var imgHint=imgEl?(imgEl.currentSrc||imgEl.getAttribute('src')||''):'';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(idEl.value,10),quantity:1}]})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        if(btn)btn.disabled=false;
        if(!res.ok){prToast((res.j&&(res.j.description||res.j.message))||T.unavail);return;}
        window.prCartPopupShow(res.j,{imgHint:imgHint});
      })
      .catch(function(){if(btn)btn.disabled=false;window.location=withPreview(CART_URL);});
  });
})();